export default __webpack_public_path__ + "static/media/Vambraces of the Dauntless.f79b6be3.jpg";